import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "edit-tenant",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "card-body overflow-auto" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "display" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_9 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_10 = { class: "card-footer footer" }
const _hoisted_11 = { class: "float-right" }
const _hoisted_12 = { class: "loader-div-40" }
const _hoisted_13 = ["src"]

import { computed, onBeforeMount, ref } from "vue";
import { ElButton, ElInput } from "element-plus";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  addTenant,
  editTenant,
  getTenant,
} from "@/tenant/services/tenant.service";
import {
  findConnectorsRelatedWithTenant,
  getConnectorListFromMaster,
} from "@/connector/services/connector.service";
import Transfer from "@/common/components/Transfer.vue";
import { currentRoute, router } from "@/core/router";
import { showAlert } from "@/core/popup";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTenant',
  setup(__props) {

const { t } = i18n.global;

const pageName = computed(() =>
  currentRoute.value.name === "createTenants"
    ? t("Common.Create")
    : t("Common.Edit")
);

const masterConnectorList = ref([]);
const connectorList = ref([]);
const id = ref();
const tenant = ref({
  id: "",
  name: "",
});

const tenantSet = ref(false);

const isValid = computed(() => tenant.value.name !== "");

const pageLoading = ref(false);

const responseLoading = ref(false);

function updateConnectors(list) {
  connectorList.value = cloneDeep(list);
}

async function saveTenant() {
  responseLoading.value = true;
  if (isValid.value && hasPermission("TENANTS.TENANT.SAVE")) {
    if (id.value) {
      await editTenant({
        tenantId: id.value,
        tenantName: tenant.value.name,
        connectorList: connectorList.value,
      }).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Tenant.TenantUpdated"));
        }
      });
    } else {
      await addTenant({
        tenantName: tenant.value.name,
        connectorList: connectorList.value,
      }).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Tenant.TenantCreated"));
        }
      });
    }
    await router.push("/tenants");
  } else if (hasPermission("TENANTS.TENANT.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
  responseLoading.value = false;
}

onBeforeMount(async () => {
  pageLoading.value = true;
  masterConnectorList.value = await getConnectorListFromMaster();
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getTenant(id.value).then(async (response) => {
      if (response) {
        tenant.value = cloneDeep(response);
        connectorList.value = await findConnectorsRelatedWithTenant(
          tenant.value.name
        );
        tenantSet.value = true;
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Common.Tenant")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Name")), 1),
              _hoisted_8
            ]),
            _createVNode(_unref(ElInput), {
              modelValue: tenant.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenant.value.name) = $event)),
              id: "tenant-name",
              placeholder: _unref(t)('Common.Name')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Connectors")), 1),
            (!id.value || tenantSet.value)
              ? (_openBlock(), _createBlock(Transfer, {
                  key: 0,
                  "source-name": "Connectors",
                  "target-name": "Tenant Connectors",
                  items: masterConnectorList.value,
                  "selected-items": connectorList.value,
                  onUpdate: updateConnectors
                }, null, 8, ["items", "selected-items"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            id: "tenant-back",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/tenants')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('TENANTS.TENANT.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                id: "tenant-submit",
                class: "btn-oneTeg2",
                onClick: saveTenant
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_13)
    ], 512), [
      [_vShow, responseLoading.value || pageLoading.value]
    ])
  ]))
}
}

})